export default {
	id: '',
	type: 'text',
	label: '',
	col: 12,
	placeholder: '',
	alert_type: 'alert-success',
	qntRows: 6,
	mask: '',
	value: '',
	disabled: false,
	aba: '',
	order: 1,
	options: {
		type: 'options',
		inTable: '',
		options: [],
		aling: '',
	},
};



// WEBPACK FOOTER //
// ./src/components/models/create-form/resets/input-smart-form.js